import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import * as S from "./styles";

export function PremioItens({ data, key }) {

    return (
        <S.Container>
            <div className="w-[220px] flex items-center justify-center py-1 xl:pl-6">
                <img src={`/assets/premios/full/${data.premio.imagem}`} />
            </div>
            <div className='divide divideFirst'></div>
            <div className='contentP font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Nome do prêmio:</p>
                <p><strong>{data.premio.nome}</strong></p>
                {data.premio.voltagem == 1 &&
                    data.voltagem
                }
            </div>
            <div className='divide'></div>
            <div className='contentP font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Solicitado em:</p>
                <p>
                    <strong>{data.criado}</strong>
                </p>
            </div>
            <div className='divide'></div>
            <div className='contentP font-secondary-xt w-[250px] flex flex-col items-center justify-center'>
                <p className="text-lg">Status:</p>
                <p>
                    <strong>{data.status_entrega}</strong>
                </p>
                {data.numero_rastreamento && (
                    <>
                        <p>Código de rastreamento:</p>
                        <p>
                            <strong>
                                {data.numero_rastreamento}
                            </strong>
                        </p>
                    </>
                )}
            </div>
            <div className='pontos font-secondary-xt py-1'>
                {`${data.premio.pontos} pontos`}
            </div>
        </S.Container>
    );
}
